export default __webpack_public_path__ + "graphics/apple--black.6d1fa6ff.svg";